import { useQuery } from "react-query";
import queryKeys from "../../constants/queryKeys";
import axios from "../../plugins/axios";

const useMeetingTranscripts = (caseActivityId) =>
    useQuery([queryKeys.meetingTranscripts, caseActivityId], async () => {
        let response = await axios.get(`${process.env.REACT_APP_CASENEST_API_URL}/getmeetingtranscripts/${caseActivityId}`);
        return response.data;
    }, {
        enabled: !!caseActivityId,
        staleTime: 600000,
        cacheTime: 900000
    });

export default useMeetingTranscripts;
